export const iconFontAwesomeWeatherTemperatureQuarter = (
	<i className="fa-solid fa-temperature-quarter"></i>
);
